import { CourseMaterial } from "./coursesLoader.ts";
import useVirtualStore from "../../common/virtual-store/useVirtualStore.tsx";
import {
  isMaterialOutOfStock,
  isMaterialUnavailable,
} from "./common/materialStoreProductUtils.ts";
import ProductOos from "../../common/product/mini-pdp/ProductOos.tsx";
import { ProductUnavailableTag } from "../../common/product/mini-pdp/ProductUnavailable.tsx";

export default function StoreStockStatusTag({
  stockItem,
}: {
  stockItem: CourseMaterial;
}) {
  const { isVirtualStore } = useVirtualStore();
  const isEpos = !!stockItem.buttonLinks.find((link) => link.type === "ePOS");

  if (!isEpos || !isVirtualStore) {
    return null;
  }

  if (isMaterialOutOfStock(stockItem)) {
    return <ProductOos />;
  }

  if (isMaterialUnavailable(stockItem)) {
    return <ProductUnavailableTag />;
  }

  return null;
}
